import React from 'react';
import classNames from 'classnames';
import PropTypes from 'prop-types';
import MuiFlatButton from 'material-ui/FlatButton';
import { connect } from 'react-redux';
import CardContainer from '../../components/card-container';
import Component from '../../components/component';
import ScrollShow from '../../components/scroll-show/index';
import FeaturedContentCard from '../../components/featured-content-card/';
import Icon, { NAMES } from '@ifit/react-icons';
import NavigationCard from '../../components/navigation-card/';
import Transition from './../../components/transition/';
import actions from './actions';
import reducer from './reducer';
import './index.css';
import { solidWhite } from './../../theme';

const manualBtnStyle = {
  width: '100%',
  height: '100%',
  padding: '5px'
};

const manualBtnLabelStyle = {
  font: '600 1rem proxima-nova',
  letterSpacing: '.2175em',
  padding: '15px'
};

const muiBtnStyles = {
  label: {
    position: 'absolute',
    width: '1px',
    height: '1px',
    padding: '0',
    margin: '-1px',
    overflow: 'hidden',
    clip: 'rect(0, 0, 0, 0)',
    border: '0'
  },
  style: {
    position: 'absolute',
    left: '50%',
    top: '50%',
    transform: 'translate(-44px, -44px)',
    background: 'rgba(46, 49, 52, .3)',
    border: `1px solid ${ solidWhite }`,
    width: '88px',
    height: '88px',
    lineHeight: '83px',
    borderRadius: '100%'
  }
};

export class PureDashboard extends Component {
  static reducer = {
    ...ScrollShow.reducer,
    dashboard: reducer
  };

  static nativeCalls = [
    setDeviceType,
    setSoftwareNumber,
    setEquipmentType
  ];

  static propTypes = {
    dashboardUrl: PropTypes.string,
    details: PropTypes.object.isRequired,
    equipmentType: PropTypes.string,
    items: PropTypes.array,
    isTransition: PropTypes.bool.isRequired,
    loading: PropTypes.bool.isRequired,
    softwareNumber: PropTypes.number,

    getCardData: PropTypes.func.isRequired,

    callNative: PropTypes.func.isRequired,
    setDetails: PropTypes.func.isRequired,
    setIsTransition: PropTypes.func.isRequired
  };

  componentDidMount() {
    this.props.getCardData();
  }

  setupTransition(details, index) {
    const { x, y, scrollY } = details;
    this.props.setIsTransition(true);
    this.props.setDetails({
      x,
      y,
      scrollY,
      index,
      item: this.props.items[index],
    });
  }

  hideTransition() {
    this.props.setIsTransition(false);
  }

  render() {
    if (!this.props.items) return null;
    return (
      <div className="workout-dashboard">
        <section>
          { this.props.items.map((item, itemIndex) => (
            <CardContainer
              img={ item.image_url }
              id={ item.id }
              key={ item.id }
              onClick={ this.onClickWorkoutCard }
              index={ itemIndex }
            >
              { itemIndex === 0
                ? (<MuiFlatButton
                  className="mui-btn"
                  label={ `Start ${ item.title } Workout` }
                  labelStyle={ muiBtnStyles.label }
                  secondary={ true }
                  icon={ <Icon name={ NAMES.VIDEO_PLAY_FILLED } color={ solidWhite } style={{ marginLeft: 0 }} /> }
                  style={ muiBtnStyles.style }
                />)
                : null }
              { this.renderCard(item) }
            </CardContainer>
          ))}
          { this.props.isTransition
            ? null
            : <ScrollShow direction="up" threshold={ 10 }>
              <div className="manual-workout-wrapper">
                <MuiFlatButton
                  href="#manual-workout"
                  label="Manual Workout"
                  style={ manualBtnStyle }
                  labelStyle={ manualBtnLabelStyle }
                  onClick={ this.onClickManualWorkout }
                />
              </div>
            </ScrollShow>
          }
        </section>
        <div className={ classNames('transition-wrapper', { active: this.props.isTransition }) }>
          <Transition
            x={ this.props.details.x }
            y={ this.props.details.y }
            scrollY={ this.props.details.scrollY }
            isVisible={ this.props.isTransition }
            onHide={ this.hideTransition }
            onShow={ this.showWorkout }
            closeAfter={ true }
          />
        </div>
      </div>
    );
  }

  renderCard(item) {
    switch (item.type) {
      case 'navigation': return (<NavigationCard {...item} />);
      default: return (<FeaturedContentCard { ...item} />);
    }
  }

  onClickManualWorkout(e) {
    e.preventDefault();
    this.startManualWorkout();
  }

  startManualWorkout() {
    this.props.callNative({ methodName: 'StartManualWorkout' });
  }

  onClickWorkoutCard(position, index) {
    this.setupTransition(position, index);
  }

  showWorkout() {
    const { item, index } = this.props.details;
    if (!item) return;

    const native = {
      tileIndex: index
    };
    if (item.navigation_type) {
      native.methodName = item.navigation_type;
    } else {
      native.methodName = 'StartWorkout';
      native.workoutId = item.workout_id; // eslint-disable-line camelcase
    }
    this.props.callNative(native);
  }
}

export function setDeviceType(payload, store) {
  if (payload.methodName !== 'deviceType') return;
  store.dispatch(actions.setDeviceType(payload.value));
  store.dispatch(actions.getCardData());
}

export function setSoftwareNumber(payload, store) {
  if (payload.methodName !== 'softwareNumber') return;
  store.dispatch(actions.setSoftwareNumber(payload.value));
  store.dispatch(actions.getCardData());
}

export function setEquipmentType(payload, store) {
  if (payload.methodName !== 'equipmentType') return;
  store.dispatch(actions.setEquipmentType(payload.value));
  store.dispatch(actions.getCardData());
}

export function mapStateToProps(state) {
  const {
    dashboardUrl,
    details,
    equipmentType,
    isTransition,
    loading,
    softwareNumber,
    items
  } = state.dashboard;

  return {
    dashboardUrl,
    details,
    equipmentType,
    isTransition,
    loading,
    softwareNumber,
    items
  };
}

export function mapDispatchToProps(dispatch) {
  return {
    getCardData: () => {
      return dispatch(actions.getCardData());
    },
    setDetails: (value) => {
      return dispatch(actions.setDetails(value));
    },
    setIsTransition: (value) => {
      return dispatch(actions.setIsTransition(value));
    }
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(PureDashboard);



// WEBPACK FOOTER //
// ./src/views/dashboard/index.jsx